/**
 * Generate Vehicle Form Url with Parameters
 * @param { String } formUrl - Form url
 * @param { Object } vehicle - Vehicle Object
 * @param { String } selectedPurchaseMethod - Selected purchase method from Calculator
 * @param { Number } vehicleInventoryId - Vehicle Inventory id
 * @param { Object } paymentOptions - Payment Options object
 * @param { Boolean } isFinanceForm - Is the form for Finance
 * @returns {String} - Form Url with Vehicle Params
 */
export const generateVehicleFormUrl = (
    formUrl,
    vehicle,
    selectedPurchaseMethod,
    vehicleInventoryId,
    paymentOptions,
    isFinanceForm = false
) => {
    const { make, model, vehicleId, stockNumber, year } = vehicle
    let extraParams = ''

    const defaultParams = {
        desired_make: make,
        desired_model: model,
        desired_year: year,
        carId: vehicleId,
        stocknumber: stockNumber,
        desired: 'inventory',
        vehicleLocation: true,
        vehicleInventoryId: vehicleInventoryId,
    }

    if (isFinanceForm) {
        const { finance, cashDown } = paymentOptions || {}
        const { term } = finance || {}
        extraParams = {
            term: term?.term,
            cashdown: cashDown,
            transaction: selectedPurchaseMethod,
        }
    }

    const params = { ...defaultParams, ...extraParams }
    const parameters = []
    Object.entries(params).map(([key, value]) => value && parameters.push(`${key}=${value}`))
    const queryString = parameters.join('&')
    return `${formUrl}?${queryString}`
}
